import { createApiCall } from 'lib/base';

const PATCH_EDIT_PROVINCE = 'PATCH_EDIT_PROVINCE';

const editProvinceApi = createApiCall<{ id: string; payload: any }>(
  PATCH_EDIT_PROVINCE,
  ({ id, payload }) => ({
    endpoint: `api/admin/provinces/${id}`,
    method: 'PATCH',
    body: payload,
  })
);

export default editProvinceApi;
